<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>
                <!--
                <v-card-title>
                    <h2>{{ $t("lengths") }}</h2>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="lengthsSearch"
                        append-icon="search"
                        :label="$t('search')"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                -->
                <v-tabs v-model="tab">
                    <v-tab>
                        <v-icon left>mdi-view-sequential</v-icon> {{ $t("lengths") }}
                    </v-tab>
                    <v-tab-item>
                        <v-toolbar card prominent dense>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.lgAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        @click="loadLengths"
                                    >
                                        <v-icon>mdi-reload</v-icon> <template v-if="$vuetify.breakpoint.lgAndUp">{{ $t("reload") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("reload") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.mdAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!acl.Create || $store.getters.subscription.settings.lengths.lock"
                                        @click="addLengthClick"
                                    >
                                        <v-icon>mdi-plus-circle-outline</v-icon> <template v-if="$vuetify.breakpoint.mdAndUp">{{ $t("create") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("create") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.mdAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!selectedRow || !acl.Modify || $store.getters.subscription.settings.lengths.lock"
                                        @click="editLengthClick(selectedRow)"
                                    >
                                        <v-icon>mdi-pencil-outline</v-icon> <template v-if="$vuetify.breakpoint.mdAndUp">{{ $t("edit") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("edit") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.mdAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!selectedRow || !acl.Delete || $store.getters.subscription.settings.lengths.lock"
                                        @click="deleteItemClick(selectedRow)"
                                    >
                                        <v-icon>mdi-delete-outline</v-icon> <template v-if="$vuetify.breakpoint.mdAndUp">{{ $t("delete") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                        </v-toolbar>

                        <v-card-text class="v-scrollable lengths-table">
                            <v-data-table
                                hide-actions
                                :headers="computedHeaders"
                                :items="lengths"
                                :search="lengthsSearch"
                                @dblclick:row="editLengthClick(selectedRow)"
                                class="dense-table"
                            >
                                <template v-slot:items="props">
                                    <tr
                                        @click="selectedRow = props.item"
                                        @dblclick:row="editLengthClick(props.item)"
                                        :class="{'grey darken-5': props.item === selectedRow}"
                                    >

                                        <td class="text-xs-left">{{ $num.dropZeros(props.item.len) }}</td>

                                        <!--
                                        <td class="text-xs-left">
                                            {{ dropZeros(props.item.len) }}
                                            <v-edit-dialog
                                                :return-value.sync="props.item.len"
                                                lazy
                                                @save="editItem(props.item)"
                                            >{{ dropZeros(props.item.len) }}
                                                <template v-slot:input>
                                                    <v-text-field
                                                        v-model="props.item.len"
                                                        :disabled="!acl.Modify"
                                                        :label="$t('length') + ', ' + $t('m')"
                                                        single-line
                                                    ></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        -->
                                        <!--
                                        <td class="justify-center layout px-0">
                                            <v-icon
                                                @click="deleteItemClick(props.item)"
                                            >
                                                delete
                                            </v-icon>
                                        </td>
                                        -->
                                    </tr>
                                </template>
                                <!--
                                <template v-slot:no-results>
                                    <v-alert :value="true" color="error" icon="warning">
                                        {{ $t("youSearchFor") }}{{ lengthsSearch }}{{ $t("foundNoResults") }}.
                                    </v-alert>
                                </template>
                                -->
                            </v-data-table>
                        </v-card-text>
                    </v-tab-item>

                    <v-tab>
                        <v-icon left>mdi-view-module</v-icon> {{ $t("lengthGroups") }}
                    </v-tab>
                    <v-tab-item>
                        <v-card-text>
                            <v-layout wrap>
                                    <v-select
                                        :items="groups"
                                        item-text="name"
                                        item-value="id"
                                        prepend-icon="mdi-view-module"
                                        v-model="selectedGroupId"
                                        :label="$t('lengthGroup')"
                                        dense
                                        hide-details
                                    ></v-select>
                            </v-layout>
                        </v-card-text>
                        <v-toolbar card prominent dense>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.lgAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!acl.Create || $store.getters.subscription.settings.lengths.lock || selectedGroupId == 0 || selectedGroupId == null"
                                        @click="saveGroupClick(null)"
                                    >
                                        <v-icon>mdi-content-save-outline</v-icon> <template v-if="$vuetify.breakpoint.lgAndUp">{{ $t("save") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("save") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.mdAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="groupItems.length == 0 || !acl.Modify || $store.getters.subscription.settings.lengths.lock"
                                        @click="saveGroupAsClick"
                                    >
                                        <v-icon>mdi-content-save-edit-outline</v-icon> <template v-if="$vuetify.breakpoint.mdAndUp">{{ $t("saveAs") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("saveAs") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.mdAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="groupItems.length == 0 || !acl.Modify || $store.getters.subscription.settings.lengths.lock || selectedGroupId == 0"
                                        @click="editGroupClick"
                                    >
                                        <v-icon>mdi-pencil-outline</v-icon> <template v-if="$vuetify.breakpoint.mdAndUp">{{ $t("rename") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("rename") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.lgAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="selectedGroupId == 0 || selectedGroupId == null || !acl.Delete || $store.getters.subscription.settings.lengths.lock"
                                        @click="deleteGroupClick"
                                    >
                                        <v-icon>mdi-delete-outline</v-icon> <template v-if="$vuetify.breakpoint.lgAndUp">{{ $t("delete") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                        </v-toolbar>

                        <v-card-text class="v-scrollable">
                            <v-data-table
                                hide-actions
                                select-all
                                :headers="computedHeaders"
                                :items="lengths"
                                :search="lengthsSearch"
                                v-model="groupItems"
                                class="dense-table"
                            >
                                <template v-slot:headers="props">
                                    <tr>
                                        <th
                                            style="width: 60px">
                                            <v-checkbox
                                                :input-value="props.all"
                                                :indeterminate="props.indeterminate"
                                                primary
                                                hide-details
                                                @click.stop="toggleAll"
                                            ></v-checkbox>
                                        </th>
                                        <th align="left">
                                            {{ computedHeaders[0].text }}
                                        </th>
                                    </tr>
                                </template>
                                <template v-slot:items="props">
                                    <td>
                                        <v-checkbox
                                            v-model="props.selected"
                                            primary
                                            hide-details
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-left">{{ $num.dropZeros(props.item.len) }}</td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs>
            </v-card>
            <edit-length-dialog ref="EditLengthDialog"/>
            <message-box        ref="MessageBox"/>
            <message-dialog     ref="MessageDialog"/>
            <text-input-dialog  ref="TextInputDialog"/>
        </v-flex>
        <v-alert
            :value="dataSavedAlert"
            type="success"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ $t("dataSaved") }}
        </v-alert>
        <v-alert
            :value="duplicateAlert"
            type="error"
            transition="scale-transition"
            class="bottom-alert"
        >
            Данная длина уже существует
        </v-alert>
         <v-alert
            :value="alert !== ''"
            type="success"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
    </v-layout>
</template>

<script>
    import EditLengthDialog from "@/components/dialogs/EditLengthDialog";
    import MessageBox       from "@/components/dialogs/MessageBox";
    import MessageDialog    from "@/components/dialogs/MessageDialog";
    import TextInputDialog  from "@/components/dialogs/TextInputDialog";

    export default {
        name: "LengthManagement",

        components: {
            EditLengthDialog,
            MessageBox,
            MessageDialog,
            TextInputDialog,
        },

        data () {
            return {
                alert:         "",
                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                breadCrumbs: [
                    { text: "Справочники", disabled: false },
                    { text: "Длины",       disabled: false }
                ],
                headers: [
                    { text: "id",       value: "id",     align: "center", sortable: true },
                    { text: "Длина, м", value: "len",    align: "left",   sortable: true } //,
                    //{ text: "Действие", value: "action", align: "center", sortable: false, width: "100px" }
                ],

                tab: 0,

                loading: {
                    groups:  false,
                    lengths: false
                },

                hideIDs: true,
                lengths: [],
                lengthsSearch: "",
                lengthsUpdated: false,
                lengthWatcher: null,
                progressBarVisible: false,
                selected: [],
                selectedRow: null,
                dataSavedAlert: false,
                duplicateAlert: false,
                dialogWatcher: null,

                groups:           [],
                groupItems:       [],
                groupItemsBackup: [],
                selectedGroupId:  null
            }

        },

        computed: {
            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(header => header.text !== "id");
                }

                return this.headers;
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            lengthsUpdated: function (val) {
                if (val) {
                    this.lengths.forEach((item) => {
                        item.len = this.$num.dropZeros(item.len);
                    });

                    this.lengthsUpdated = false;
                }
            },

            duplicateAlert: function (val) {
                if (val) {
                    setTimeout(() => this.duplicateAlert = false, 1500);
                }
            },

            dataSavedAlert: function (val) {
                if (val) {
                    setTimeout(() => this.dataSavedAlert = false, 1500);
                }
            },

            selectedGroupId: function (val) {
                let ids = this.groups.filter(data => data.id == val).length > 0
                    ? this.groups.filter(data => data.id == val)[0].lengthIds
                    : [];

                this.groupItems = this.lengths.filter(data => ids.includes(data.id));
                this.groupItemsBackup = [...this.groupItems];
            },

        },

        mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();
            this.loadLengths();
            this.loadGroups();

            if (this.$store.getters.user.acl) {
                this.$store.getters.user.acl.forEach((aclRecord) => {
                    if (aclRecord.Module.Name == "lengths") {
                        this.acl = aclRecord;
                    }
                });
            }

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Обработчик нажатия кнопки добавления новых значений длин
             */
            addLengthClick () {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.EditLengthDialog.saveData",
                    (val) => {
                        if (val) {
                            let vLen = parseFloat(this.$refs.EditLengthDialog.length.toString().replace(',','.'));
                            if (vLen) {
                                //Добавление одиночного значения длины

                                if (this.checkDuplicates(vLen)) {
                                    this.axios({
                                        method: "post",
                                        url: `${this.$config.apiURL}lengths/`,
                                        data: { Ln: parseFloat(this.$refs.EditLengthDialog.length.replace(',','.')) * 1000 },
                                        withCredentials: true
                                    }).then(() => {
                                        this.dataSavedAlert = true;
                                        //this.dataUpdated    = true;
                                        this.loadLengths();
                                    }).catch(error => {
                                        if (error.response && error.response.status == 401) {
                                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                                            // Удаление наблюдателя если установлен
                                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                            // Отслеживание нажатия кнопки ok в диалоге
                                            this.dialogWatcher = this.$watch(
                                                "$refs.MessageBox.dialog",
                                                () => { window.location.reload(); }
                                            );
                                        } else if (error.response && error.response.status == 402) {
                                            this.showMessageBox(this.$t("error"), this.$t("cantUpdateLength") + ". " + this.$t("subscriptionExpired"));

                                            // Удаление наблюдателя если установлен
                                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                            // Отслеживание нажатия кнопки ok в диалоге
                                            this.dialogWatcher = this.$watch(
                                                "$refs.MessageBox.dialog",
                                                () => { this.$emit("doLogout", true); }
                                            );
                                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                        } else if (error.response && error.response.status == 403) {
                                            this.showMessageBox(this.$t("error"), this.$t("cantUpdateLength") + ". " + this.$t("accessDenied"));
                                        } else {
                                            this.showMessageBox(this.$t("error"), this.$t("cantUpdateLength"));
                                        }
                                    });
                                }
                                else {
                                    this.duplicateAlert = true;
                                }
                            } else {
                                //Добавление диапазона длин

                                const valueFrom = parseFloat(this.$refs.EditLengthDialog.valueFrom.replace(",", "."));
                                const valueTo   = parseFloat(this.$refs.EditLengthDialog.valueTo.replace(",", "."));
                                const step      = parseFloat(this.$refs.EditLengthDialog.step.toString().replace(",", "."));

                                for (let c = valueFrom; c <= valueTo; c += step) {
                                    if (this.checkDuplicates(c)) {
                                        this.axios({
                                            method: "post",
                                            url: `${this.$config.apiURL}lengths/`,
                                            data: { Ln: Math.round(c * 1000) },
                                            withCredentials: true
                                        }).then(() => {
                                            this.dataSavedAlert = true;
                                            //this.dataUpdated    = true;
                                            this.loadLengths();
                                        }).catch(error => {
                                            if (error.response && error.response.status == 401) {
                                                this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                                                // Удаление наблюдателя если установлен
                                                if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                                // Отслеживание нажатия кнопки ok в диалоге
                                                this.dialogWatcher = this.$watch(
                                                    "$refs.MessageBox.dialog",
                                                    () => { window.location.reload(); }
                                                );
                                            } else if (error.response && error.response.status == 402) {
                                                this.showMessageBox(this.$t("error"), this.$t("cantUpdateLength") + ". " + this.$t("subscriptionExpired"));

                                                // Удаление наблюдателя если установлен
                                                if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                                // Отслеживание нажатия кнопки ok в диалоге
                                                this.dialogWatcher = this.$watch(
                                                    "$refs.MessageBox.dialog",
                                                    () => { this.$emit("doLogout", true); }
                                                );
                                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                            } else if (error.response && error.response.status == 403) {
                                                this.showMessageBox(this.$t("error"), this.$t("cantUpdateLength") + ". " + this.$t("accessDenied"));
                                            } else {
                                                this.showMessageBox(this.$t("error"), this.$t("cantUpdateLength"));
                                            }
                                        });
                                    }
                                }

                            }

                        }
                    }
                );

                this.$refs.EditLengthDialog.resetForm();
                this.$refs.EditLengthDialog.lengths = this.lengths;
                this.$refs.EditLengthDialog.saveData  = false;
                this.$refs.EditLengthDialog.dialog  = true;
            },

            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",               value: "id",     align: "center", sortable: true },
                    { text: this.$t("lengthM"), value: "len",    align: "left",   sortable: true } //,
                    //{ text: this.$t("action"),  value: "action", align: "center", sortable: false, width: "100px" }
                ];

                this.breadCrumbs = [
                    { text: this.$t("catalogs"), disabled: false },
                    { text: this.$t("lengths"),  disabled: false }
                ];

                if (this.groups.length > 0) {
                    this.groups[0].name = this.$t("newGroup");
                }
            },

            /**
             * Проверка новых значений на дубликаты
             *
             * @param {number} len Значение длины для проверки
             *
             * @returns {bool}
             */
            checkDuplicates (len) {
                for (let item of this.lengths) {
                    if (len == item.len) return false;
                }
                return true;
            },

            /**
             * Удаление элемента
             *
             * @param {object} item Информация об удаляемом элементе
             */
            deleteItem (item) {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}lengths/${item.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.loadLengths();
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLength") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLength") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLength"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки удаления длины
             *
             * @param {object} item Информация об удаляемом элементе
             */
            deleteItemClick (item) {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteItem(item); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("lengthDelete");
                this.$refs.MessageDialog.messageText = `${this.$t("confirmLengthDelete")} (${item.len} ${this.$t("m")})`;
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Удаление группы
             */
            deleteGroup () {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}length_groups/${this.selectedGroupId}/`,
                    withCredentials: true
                }).then(() => {
                    this.loadGroups();
                    this.selectedGroupId = 0;
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLengthGroup") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLengthGroup") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLengthGroup"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки удаления группы
             */
            deleteGroupClick () {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteGroup(); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("lengthGroupDelete");
                this.$refs.MessageDialog.messageText = this.$t("confirmLengthGroupDelete");
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Обработчик нажатия кнопки редактирования группы
             */
            editGroupClick () {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                this.dialogWatcher = this.$watch(
                    "$refs.TextInputDialog.answer",
                    (val) => {
                        if (val) {
                            if (this.$refs.TextInputDialog.textInput.trim() == "") {
                                this.$refs.MessageBox.title       = this.$t("error");
                                this.$refs.MessageBox.messageText = this.$t("groupNameCantBeEmpty");
                                this.$refs.MessageBox.dialog      = true;
                            } else {
                                this.saveGroupClick(this.$refs.TextInputDialog.textInput);
                            }
                        }
                    }
                );

                this.$refs.TextInputDialog.title     = this.$t("saveGroup");
                this.$refs.TextInputDialog.hintText  = this.$t("groupName");
                this.$refs.TextInputDialog.textInput = this.groups.filter(data => data.id == this.selectedGroupId).length > 0
                    ? this.groups.filter(data => data.id == this.selectedGroupId)[0].name
                    : "";
                this.$refs.TextInputDialog.dialog    = true;
            },

            /**
             * Удаляет незначащие нули
             *
             * @param {number} val Исходное значение
             *
             * @returns {string}
             */
            /*
            dropZeros (val) {
                let result = parseFloat(val);

                    result = result.toFixed(3).substring(result.toFixed(3).length, result.toFixed(3).length - 1) == "0"
                        ? parseFloat(result.toFixed(2))
                        : parseFloat(result.toFixed(3));

                if (result == parseInt(val)) {
                    result += ".0";
                }

                return result;
            },
            */

            /**
             * Обработчик нажатия кнопки изменения значения длины
             *
             * @param {object} Информация о длине
             */
            editLengthClick (item) {
                //this.$debug.log(item);
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.EditLengthDialog.saveData",
                    (val) => {
                        if (val) {
                            //this.editItem(item);
                            let vLen = parseFloat(this.$refs.EditLengthDialog.length.toString().replace(',','.'));
                            if (this.checkDuplicates(vLen)) {
                                this.axios({
                                    method: "patch",
                                    url: `${this.$config.apiURL}lengths/${item.id}/`,
                                    data: { Ln: parseFloat(this.$refs.EditLengthDialog.length.replace(',','.')) * 1000 },
                                    withCredentials: true
                                }).then(() => {
                                    this.dataSavedAlert = true;
                                    //this.dataUpdated    = true;
                                    this.loadLengths();
                                }).catch(error => {
                                    if (error.response && error.response.status == 401) {
                                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                                        // Удаление наблюдателя если установлен
                                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                        // Отслеживание нажатия кнопки ok в диалоге
                                        this.dialogWatcher = this.$watch(
                                            "$refs.MessageBox.dialog",
                                            () => { window.location.reload(); }
                                        );
                                    } else if (error.response && error.response.status == 402) {
                                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateLength") + ". " + this.$t("subscriptionExpired"));

                                        // Удаление наблюдателя если установлен
                                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                        // Отслеживание нажатия кнопки ok в диалоге
                                        this.dialogWatcher = this.$watch(
                                            "$refs.MessageBox.dialog",
                                            () => { this.$emit("doLogout", true); }
                                        );
                                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                    } else if (error.response && error.response.status == 403) {
                                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateLength") + ". " + this.$t("accessDenied"));
                                    } else {
                                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateLength"));
                                    }
                                });
                            }
                            else {
                                this.duplicateAlert = true;
                            }

                        }
                    }
                );

                this.$refs.EditLengthDialog.resetForm();
                this.$refs.EditLengthDialog.length  = item.len;
                this.$refs.EditLengthDialog.lengths = this.lengths;
                this.$refs.EditLengthDialog.saveData  = false;
                this.$refs.EditLengthDialog.dialog  = true;

            },

            /**
             * Инициализация наблюдателя за изменением длины
             */
            initLengthWatcher () {
                if (this.lengthWatcher !== null) {
                    this.lengthWatcher();
                }

                /* Отслеживание изменения флага изменения данных */
                this.lengthWatcher = this.$watch(
                    "$refs.EditLengthDialog.dataUpdated",
                    (val) => {
                        if (val) {
                            this.dataSavedAlert = true;
                            this.loadLengths();
                        }
                    }
                );
            },

            /**
             * Загрузка групп длин
             */
            loadGroups () {
                this.loading.groups = true;

                this.axios.get(`${this.$config.apiURL}length_groups/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let groups = response.data.groups;

                            this.groups = [];

                            groups.forEach((item) => {
                                //if (item.Visible) {
                                    let lengthIds = [];

                                    item.LengthGroupsData.forEach(data => {
                                        lengthIds.push(parseInt(data.LengthId));
                                    });

                                    this.groups.push({
                                        id:        item.id,
                                        name:      item.Name,
                                        lengthIds: lengthIds,
                                    });
                                //}
                            });
                        }

                        if (this.groups.filter(data => data.id == 0).length == 0) {
                            this.groups.unshift({
                                id:        0,
                                name:      this.$t("newGroup"),
                                lengthIds: [],
                            });
                            //this.selectedGroupId = 0;
                        }

                        if (this.selectedGroupId == null) {
                            this.selectedGroupId = 0;
                        }

                        this.loading.groups = false;
                    })
                    .catch(error => {
                        this.loading.groups = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData"));
                        }
                    });
            },

            /**
             * Загрузка длин
             */
            loadLengths () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}lengths/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let lengthsInfo = response.data.lengths

                            this.lengths = [];

                            lengthsInfo.forEach((item) => {
                                this.lengths.push({
                                    id:  item.id,
                                    len: item.Ln / 1000
                                });
                            });
                        }

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData"));
                        }
                    });
            },

            /**
             * Сохраняет группу длин с новым названием
             *
             * @param {string} name Название группы
             */
            saveGroupAs (name) {
                let items = [];

                this.groupItems.forEach(item => {
                    items.push(item.id);
                });

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}length_groups/`,
                    data: {
                        name:      name,
                        dataJSON:  JSON.stringify(items)
                    },
                    withCredentials: true
                }).then(response => {
                    if (response.status == 200 ) {
                        if (response.data.status == "attention") {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveLengthGroup"));
                        } else {
                            this.alertType   = "success";
                            this.alert       = this.$t("lengthGroupSaved");
                            //this.dataUpdated = true;
                            //this.lineChanged = false;
                            this.loadGroups();
                        }
                    }
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLengthGroup") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLengthGroup") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLengthGroup"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки сохранения группы под новым именем
             */
            saveGroupAsClick () {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                this.dialogWatcher = this.$watch(
                    "$refs.TextInputDialog.answer",
                    (val) => {
                        if (val) {
                            if (this.$refs.TextInputDialog.textInput.trim() == "") {
                                this.$refs.MessageBox.title       = this.$t("error");
                                this.$refs.MessageBox.messageText = this.$t("groupNameCantBeEmpty");
                                this.$refs.MessageBox.dialog      = true;
                            } else {
                                this.saveGroupAs(this.$refs.TextInputDialog.textInput);
                            }
                        }
                    }
                );

                this.$refs.TextInputDialog.title     = this.$t("saveGroup");
                this.$refs.TextInputDialog.hintText  = this.$t("groupName");
                this.$refs.TextInputDialog.textInput = this.groups.filter(data => data.id == this.selectedGroupId).length > 0
                    ? this.groups.filter(data => data.id == this.selectedGroupId)[0].name
                    : "";
                this.$refs.TextInputDialog.dialog    = true;
            },

            /**
             * Обработчик нажатия кнопки сохранения группы
             *
             * @param {string} newName Новое название группы
             */
            saveGroupClick (newName = null) {
                let items = [];
                let name  = this.groups.filter(data => data.id == this.selectedGroupId).length > 0
                    ? this.groups.filter(data => data.id == this.selectedGroupId)[0].name
                    : "";

                if (name.trim() == "") {
                    this.saveGroupAsClick();
                    return;
                }

                this.groupItems.forEach(item => {
                    items.push(item.id);
                });

                this.axios({
                    method: "patch",
                    url: `${this.$config.apiURL}length_groups/${this.selectedGroupId}/`,
                    data: {
                        name: newName == null || newName.trim() == ""
                            ? name
                            : newName,
                        dataJSON:  JSON.stringify(items)
                    },
                    withCredentials: true
                }).then(response => {
                    if (response.status == 200 ) {
                        if (response.data.status == "attention") {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveLengthGroup"));
                        } else {
                            this.alertType   = "success";
                            this.alert       = this.$t("lengthGroupSaved");
                            //this.dataUpdated = true;
                            //this.lineChanged = false;
                            this.loadGroups();
                        }
                    }
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLengthGroup") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLengthGroup") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLengthGroup"));
                    }
                });
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /*
            showNewLengthDlg () {
                this.initLengthWatcher();
                this.$refs.EditLengthDialog.resetForm();
                this.$refs.EditLengthDialog.lengths = this.lengths;
                this.$refs.EditLengthDialog.dialog  = true;
            }
            */

            /**
             * Выбор всех длин
             */
            toggleAll () {
                this.groupItems = this.groupItems.length ? [] : this.lengths.slice();
            },
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 250px)
</style>
